export default __webpack_public_path__ + "static/media/Iron-Category-Offer.42817ea3.png";